module.exports = __webpack_public_path__ + "img/number_l_spritesheet.7d1428ce.png";